/**
 * Purpose: Application entry point — mounts the React app into the DOM.
 * Owns: Root render call, global CSS import.
 * Notes: The #root element is defined in index.html. Global styles (CSS reset,
 *        theme variable fallbacks) are imported here before any components.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';
import './styles/chalkboard-textures.css';
import './styles/chalk-text.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in document');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
